import React from 'react';
import { Container, Row, Col, Button, Badge } from 'react-bootstrap';
import t from '../../Components/Translations/lang.json';

const Footer = ({ tip }) => {

    var url = new URL(window.location);
    var lang = url.searchParams.get('language')
        ? url.searchParams.get('language')
        : 'de';
    const currentLang = lang;

    return (
        <Container fluid className='footer-btm'>
            <Row className={'text-left pt-4'}>
                 {/*<Col xs={2} className=' text-right'>*/}
                    <Badge variant='light' className='tipBx'>
                        {/*TIPP*/}
			{t[currentLang].hint}
                    </Badge>
                {/*</Col>*/}
                {/*<Col xs={10}>*/}
                    <h6 className='footer-tip-txt'>{tip}</h6>
                {/*</Col>*/}
            </Row>
        </Container>
    );
};

export default Footer;
